import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class VerticalStopsListComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 400.0 * dimentionsRatio;
        const geometryHeightRatio = geometry.height / 1200.0 * dimentionsRatio;

        const textElementPosX = geometry.drawPositionX + 50 * geometryWidthRatio;
        const textElementPosY = geometry.drawPositionY + 50 * geometryHeightRatio;

        const componentSecundaryColor = "#C3E2F0";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        let fontSize = 35;
        if (6 * fontSize > geometryWidth) {
            fontSize = geometryWidth / 6.0;
        }
        if (fontSize > geometryHeight) {
            fontSize *= geometryHeight / fontSize;
        }

        const rectElements = [];
        let nextRectPosY = textElementPosY + fontSize + 10;
        const rectPosX = geometry.drawPositionX + 50 * geometryWidthRatio;
        const rectHeight = 20;
        const rectWidth = 300 * geometryWidthRatio;

        const heightLimit = geometryHeight + geometry.drawPositionY - 5;
        while (heightLimit > nextRectPosY + rectHeight) {
            rectElements.push(
                <Group key={nextRectPosY}>
                    <Rect x={rectPosX}
                        y={nextRectPosY}
                        width={rectWidth}
                        height={rectHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            );

            nextRectPosY += rectHeight + 10;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Text text="Espinha"
                        fontSize={fontSize}
                        x={textElementPosX}
                        y={textElementPosY} />
                </Group>

                {rectElements}
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/VerticalStopsListComponentCanvas.js